import React from 'react'
import BatchShipHead from './BatchShipTable/BatchShipHead'
import BatchShipRow from './BatchShipTable/BatchShipRow'
import { getLocalData } from '../../../services/StorageServices'

function BatchShipTable(props) {
    const { listBatchShip, loading, reload, selectAll, onCheckALl, arrSelected, onSelected, status, boxCarrier} = props
    const userRoles = !!getLocalData('roles') && getLocalData('roles').length > 0 ? getLocalData('roles').map(i => i.name) : []
    const batchShipPermissions = !!getLocalData('user') && getLocalData('user').batch_ship

    return (
        <div className='BatchShipTable'>
            <div className="wrapTable">
                <table className='table mb-4'>
                    <BatchShipHead 
                        userRoles={userRoles} 
                        selectAll={selectAll}
                        onCheckALl={onCheckALl}
                        arrSelected={arrSelected}
                        status={status}
                        boxCarrier={boxCarrier}
                    />
                    <tbody>
                        {
                            !!listBatchShip && listBatchShip.map((item, i) => {
                                return <BatchShipRow
                                    key={item._id}
                                    index={i}
                                    item={item}
                                    reload={reload}
                                    userRoles={userRoles}
                                    batchShipPermissions={batchShipPermissions}
                                    arrSelected={arrSelected}
                                    onSelected={onSelected}
                                    batchStatus={status}
                                    boxCarrier={boxCarrier}
                                />
                            })
                        }
                        {
                            !loading && listBatchShip.length === 0 &&
                            <tr>
                                <td colSpan={11}>
                                    No result
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

        </div>
    )
}

export default BatchShipTable